export default "__VITE_ASSET__BOBtCJpe__"